import BleExtensionClient from "./BleExtensionClient";
import { IBleEventArgs } from "./EventEmitter";
import { IBleExtensionMessage, IBleExtensionMessageData } from "./Models";
import { ExtensionRequestError } from "./errors/ExtensionRequestError";
import WriteMesssageTimeoutError from "./errors/WriteMessageTimeourError";

const SEND_MESSAGE_TIMEOUT = 3000;

export async function sendMessageAsync<T>(messageData: IBleExtensionMessageData<T>, timeoutMs = SEND_MESSAGE_TIMEOUT): Promise<T> {
    if(!messageData?.type) {
        throw new Error("Message data error")
    }

    let messageId: number | null;
    let timeout: any;
    let resolve: (arg0: T) => void;
    let reject: (arg0: Error) => void;

    const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    })

    const bleExtensionClient = new BleExtensionClient();
    const onMessage = (event: IBleEventArgs<IBleExtensionMessage<any>>) => {
        const {id, data } = event.data as IBleExtensionMessage<T>;
        if(messageId === id && data?.type === messageData.type && (data?.response || data?.error)) {                
            if(data.error) {
                clearTimeout(timeout);
                reject(new ExtensionRequestError("Send message error retrieved.", data.error))
            }

            if(data?.response) {
                clearTimeout(timeout);
                resolve(data?.response)
            }                
        }
    }

    bleExtensionClient.addOnMessageEventListener(onMessage);

    try {
        timeout = setTimeout(() => reject(new WriteMesssageTimeoutError("WriteTimeout error")), timeoutMs);
        messageId = bleExtensionClient.sendMessage(messageData);    
        return await promise;
    } finally {
        bleExtensionClient.removeOnMessageEventListener(onMessage);
    }
}